export enum GameState {
  MAIN = 0,
  SETTINGS = 1,
  SELECTION = 2,
  LEVEL = 3,
  OVER = 4,
  SUCCESS = 5,
  FINISH = 6,
  INTRO = 7,
}
